import styled from 'styled-components';

const ErrorText = styled.div`
  font-weight: 300;
  font-size: ${({ fontSize }) => fontSize || '10px'};
  color: #b94a48;
  line-height: 14px;
  bottom: 5px;
  position: absolute;
  white-space: nowrap;
  left: 0;
`;

export default ErrorText;
